const getSelectionBounds = (element) => {
  try {
    if (!element || typeof element !== "object") {
      return null;
    }

    const selectionStart = element.selectionStart;
    const selectionEnd = element.selectionEnd;

    if (typeof selectionStart !== "number" || typeof selectionEnd !== "number") {
      return null;
    }

    return {
      selectionStart,
      selectionEnd,
      valueLength: String(element.value ?? "").length,
    };
  } catch {
    return null;
  }
};

const canNavigateHorizontally = (element, direction) => {
  const bounds = getSelectionBounds(element);
  if (!bounds) {
    return true;
  }

  if (direction === "left") {
    return bounds.selectionStart === 0 && bounds.selectionEnd === 0;
  }

  return (
    bounds.selectionStart === bounds.valueLength &&
    bounds.selectionEnd === bounds.valueLength
  );
};

export const handleArrowFieldKeyDown = (
  event,
  { onLeft, onRight, onEnter } = {}
) => {
  if ((event.key === "Enter" || event.key === "NumpadEnter") && typeof onEnter === "function") {
    event.preventDefault();
    onEnter(event);
    return true;
  }

  if (
    event.key === "ArrowLeft" &&
    typeof onLeft === "function" &&
    canNavigateHorizontally(event.currentTarget, "left")
  ) {
    event.preventDefault();
    onLeft(event);
    return true;
  }

  if (
    event.key === "ArrowRight" &&
    typeof onRight === "function" &&
    canNavigateHorizontally(event.currentTarget, "right")
  ) {
    event.preventDefault();
    onRight(event);
    return true;
  }

  return false;
};
